<template>
    <div class="content">
        <div class="wsBox">
            <ul v-if="isWs" class="wsUl">
                <li v-for="(item,index) in wsList" :key="index">
                    <div class="lft">
                        <img :src="item.src" alt="">
                        <p class="btns">
                            <el-button type="text" icon="el-icon-view" @click="show2(item)" style="color:#67c23a;">预览</el-button>
                            <el-button type="text" icon="el-icon-printer" @click="show2(item)">打印</el-button>
                            <el-button type="text" icon="el-icon-edit" @click="edit(item)">修改</el-button>
                            <el-button type="text" icon="el-icon-delete" @click="del(item)" >删除</el-button>
                        </p>
                    </div>
                    <div class="rit">
                        <p>照片编号：{{item.nianfen}}-{{item.bianhao}}</p>
                        <h3>说明反映的问题：</h3>
                        <p>{{item.wenti}}</p>
                    </div>
                </li>
            </ul>
            <p v-else style="text-align: center;padding-top: 30px;min-height: 123px; font-size: 30px; color: #000;box-shadow: 1px 1px 10px rgb(0 0 0 / 30%); border-radius: 3px;">
                还没有已经生成的文书
            </p>
            
        </div>
        <div style="text-align:center;">
            <el-button type="primary" @click="getZpzj">增加现场照片证据</el-button>
        </div>
        <el-dialog title="现场照片证据" :visible.sync="open" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <h2 style="text-align: center; margin-bottom:15px;">现场照片证据</h2>
            <el-form :model="form" ref="form" :rules="rules" label-width="110px">
                <el-row :gutter="30">
                    <el-col :span="12">
                    <el-col :span="24">
                        <el-form-item label="编号:" prop="bianhao">
                            <b>{{form.nianfen}} - </b>
                            <el-input style="width:120px; margin-right:10px;"
                            v-model="form.bianhao" :disabled="form.lsh?true:false"
                            placeholder="请输入"
                            clearable
                            size="small"
                            />
                            <el-button type="warning" size="small" @click="getBh">获取编号</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="取证时间:" prop="qzShijian">
                            <el-date-picker size="small"
                                v-model="form.qzShijian"
                                type="datetime"
                                placeholder="选择日期时间" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="取证人员:" prop="qzRenDm">
                            <el-select v-model="form.qzRenDm" placeholder="请选择" size="small" style="width:140px;">
                                <el-option
                                v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.dm"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-select v-model="form.qzRenDm2" placeholder="请选择" size="small" style="width:140px;">
                                <el-option
                                v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.dm"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="取证地点:" prop="qzdidian">
                            <el-input
                            v-model="form.qzdidian"
                            placeholder="请输入"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="反映问题:" prop="wenti">
                            <el-input type="textarea" rows="5"
                            v-model="form.wenti"
                            placeholder="请输入"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="imgList" label-width="0">

                            <div class="imgs" v-if="imgList">
                                <p v-for="(item,index) in imgList" :key="index">
                                    <img :src="item" class="avatar" />
                                    <span><i class="el-icon-delete" @click="delImg(index)"></i></span>
                                </p>
                            </div>
                            <el-upload v-if="imgList.length < 4"
                                class="avatar-uploader"
                                action="#"                  
                                :before-upload="beforeAvatarUpload"
                                :show-file-list="false"  
                                >
                                
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" @click="onSubmitTp" style="margin-top:20px;">上传照片</el-button>
                            
                            
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0" style="text-align:center;">
                            <el-button type="primary" @click="submit('form')">生成现场照片证据</el-button>
                            <el-button type="warning" @click="show()">预览</el-button>
                            <el-button type="danger" v-if="isWs" @click="editWordBj()">编辑</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div v-if="loading" class="loading">
                <i class="el-icon-loading"></i>
                <p>文书生成中...</p>
            </div>
        </el-dialog>
        
        <el-dialog title="现场照片证据" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'


export default {
    name: "Layout",
    props:['code','pcId','dwdz','dwmc','jcrq','mid','lsh'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
                lsh:'',
                nianfen:new Date().getFullYear() + '',
                bianhao:'',
                qzdidian:'',
                qzShijian:this.getDate(new Date(),'yyyy-MM-dd hh:mm:ss'),
                wenti:'',
                tpname:'',
                flag:0,
                qzRemDm:'',
                qzRemDm2:'',
            },
            rules:{
                bianhao:[
                    { required: true, message: '编号不能为空', trigger: 'blur' }
                ],
                qzdidian:[
                    { required: true, message: '取证地点不能为空', trigger: 'blur' }
                ],
                wenti:[
                    { required: true, message: '反映问题不能为空', trigger: 'blur' }
                ],
                qzShijian:[
                    { required: true, message: '取证时间不能为空', trigger: ['change','blur'] }
                ],
                qzRemDm:[
                    { required: true, message: '取证人员不能为空', trigger: ['change','blur'] }
                ],
                qzRemDm2:[
                    { required: true, message: '取证人员不能为空', trigger: ['change','blur']  }
                ],
            },
            isWs:false,
            xcLsh:'',
            wsList:[],
            open:false,
            userOptions:[],
            mrtext:'',
            org:'',

            fileName:'',
            files:{},
            imgUrl:'',
            imgList:[],

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        this.org = user.jcjg
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(async response => {
            this.userOptions = response.data.data || []
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        this.getZfxx()
        this.getList()
        this.getText()
    },
    methods: {
        async getBh(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXczpwsBhpc&id=${this.pcId}&nianFen=${this.form.nianfen}`)
            console.log(data)
            if(data.data){
                if(data.data[0]){
                    this.$set(this.form,'bianhao',data.data[0].data)
                }
            }
        },
        async getZpzj(){
            this.form = {
                lsh:'',
                nianfen:new Date().getFullYear() + '',
                bianhao:'',
                qzdidian:this.dwdz,
                qzShijian:this.getDate(new Date(),'yyyy-MM-dd hh:mm:ss'),
                wenti:this.mrtext,
                tpname:'',
                flag:0,
                qzRemDm:'',
                qzRemDm2:'',
            }
            this.imgList = []
            this.imgUrl = ''
            this.open = true
        },
        async getText(){
            let date = this.getDate(this.jcrq,'yyyy-MM-dd')
            let str = date.split('-')[0]+'年'+date.split('-')[1]+'月'+date.split('-')[2]+'日'
            this.mrtext =  str+'，' +this.org+'执法人员着装出示执法证对'+this.dwdz+'的'+this.dwmc+'进行检查，检查发现：'

        },
        async getList(){
            
            this.getWsList()
        },
        async getWsList(){
            this.isWs = false
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXczpws1&pcId=${this.pcId}`)
            console.log(data)
            if(data.data){
                if(data.data.length > 0){
                    //有dw287/2…opian/tupian/de5d0423e59542009719e2c2f7beed6d.jpg
                    this.isWs = true
                    this.wsList = data.data
                    this.wsList.forEach(item => {
                        let dz = ''
                        if(item.tpname.indexOf(',') != -1){
                            dz = item.tpname.split(',')[0]
                        }else{
                            dz = item.tpname
                        }
                        let img = 'https://dapc1.scqwszfd.cn:8123/zfjl/' + this.mid + '/' + this.lsh + '/xianchangzhaopian/tupian/'+dz
                        item.src = img
                    });
                }else{
                    this.isWs = false
                }
                
            }
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.dwXx = data.data[0]
            }
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    console.log(this.form)
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "setXczpws",
                            pcId: `${this.pcId}`,
                            lsh: `${this.xcLsh}`,
                            nianfen:`${escape(this.form.nianfen)}`,
                            bianhao:`${escape(this.form.bianhao)}`,
                            qzDidian:`${escape(this.form.qzdidian)}`,
                            qzShijian:`${escape(this.form.qzShijian)}`,
                            wenti:`${escape(this.form.wenti)}`,
                            tpName:`${escape(this.imgUrl)}`,
                            flag:`${escape(this.form.flag)}`,
                            qzRenDm:`${escape(this.form.qzRenDm)}`,
                            qzRenDm2:`${escape(this.form.qzRenDm2)}`,
                            // gzzw:`${escape(this.gzzw)}`,
                            // xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data != -1){
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.xcLsh = res.data
                            this.show()
                            this.getWsList() 
                        }else{
                            this.$message({
                                message: '保存失败，请重新填写',
                                type: 'error'
                            });
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        show(){
            if(this.xcLsh){
                console.log('1308')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:this.dwXx.dwmc_id,
                        lsh:this.lsh,
                        wsname:'xianchangzhaopian',
                        blLsh:this.xcLsh
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        show2(item){
            let url = this.$router.resolve({
                path:'/pdf',
                query:{
                    mid:item.strMid,
                    lsh:item.strLsh,
                    wsname:'xianchangzhaopian',
                    blLsh:item.lsh
                }
            })
            window.open(url.href,'_blank')
        },
        edit(item){
            this.form = item
            this.imgList = []
            this.imgUrl = ''
            if(item.tpname){
                this.imgUrl = item.tpname
               if(item.tpname.indexOf(',') != -1){
                    let arr = item.tpname.split(',')
                    arr.forEach(ele => {
                        if(ele){
                            let img = 'https://dapc1.scqwszfd.cn:8123/zfjl/' + this.mid + '/' + this.lsh + '/xianchangzhaopian/tupian/'+ele
                            this.imgList.push(img)
                        }
                    })
                }else{
                    
                    let img = 'https://dapc1.scqwszfd.cn:8123/zfjl/' + this.mid + '/' + this.lsh + '/xianchangzhaopian/tupian/'+item.tpname
                    console.log(img)
                    this.imgList.push(img)
                    
                } 
            }
            this.xcLsh = item.lsh
            console.log(this.form)
            this.open = true
        },
        del(item){
            this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                this.$axios.get(`${this.Global._baseUrl2}?act=delXczpws&lsh=${item.lsh}`)
                .then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getWsList() 
                }).catch(err => {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },

        beforeAvatarUpload(file) {
            this.files = ''
            this.fileName = ''
            console.log(file)
            this.files = file;
            const isJPEG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isJPG = file.type === 'image/jpg'
            const isGIF = file.type === 'image/GIF'
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!(isJPEG || isPNG || isJPG || isGIF)) {
                this.$message.error('上传图片只能是 JPEG/PNG/JPG/GIF 格式!')
                return false // 返回false不会自动上传
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false // 返回false不会自动上传
            }
            this.fileName = file.name;
            // this.$set(this.form,'tpname',URL.createObjectURL(file));
            //return false // 返回false不会自动上传
            if(this.files){
                this.onSubmitTp ()
            }
            
        },
        delImg(index){
            this.imgList.splice(index,1)
            let arr = this.imgUrl.split(',')
            arr.splice(index,1)
            this.imgUrl = arr.join(',')
            console.log(this.imgUrl)
        },
        async onSubmitTp () {
            console.log(this.files)
            if(this.imgList.length >= 4){
                this.$message.error('最多可以上传4张图片！')
                return false
            }
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的图片！')
                return false
            }
            let fileFormData = new FormData();
            fileFormData.append('file',this.files );
            let config = {
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            }
            this.$axios.post(`${this.Global._baseUrl2}?act=uploadXcFile11&pcId=${this.pcId}&uploadFileName=${this.fileName}&type=xianchangzhaopian`,fileFormData, config)
            .then(res => {
                console.log(res.data)
                if(res.data.error == 0){
                    
                    console.log(res.data.filenewname)
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.imgUrl = this.imgUrl ? this.imgUrl + ','+res.data.filenewname : res.data.filenewname
                    this.imgList.push('https://dapc1.scqwszfd.cn:8123/zfjl/' + this.mid + '/' + this.lsh + '/xianchangzhaopian/tupian/'+res.data.filenewname)
                }
            }).catch(err => {
                console.log(err)
                this.$message({
                    message: '上传失败',
                    type: 'error'
                });
            })
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        
        async editWordBj(){
            this.dialogWordVisible = true
            console.log(this.xcLsh)
            this.docurl = ''
            this.wsPdf = ''
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixczp&pcId=${this.pcId}`)
            if(data.data){
                let arr = data.data
                arr.forEach((ele,index) => {
                    if(ele.lsh == this.xcLsh){
                        this.docurl = ele.docurl
                        this.wsPdf =  'https://dapc1.scqwszfd.cn:8123/zfjl/'+ele.mid+'/'+ele.lsh1+'/xianchangzhaopian/tupian/'+ele.lsh+'.pdf'
                    }
                    //this.xczpOptions.push({name:'现场照片证据'+(index+1)+'',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                })
            }
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'xianchangzhaopian.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dwXx.dwmc_id}&lsh=${this.dwXx.lsh}&filecode=${wsname}&DaLsh=${this.xcLsh}`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },

    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}

.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.wsBox{ margin: 20px 0;}
.wsUl{padding: 10px;max-height: 520px; overflow-y: auto;}
.wsUl li{width: calc(100% - 30px);padding: 15px; overflow: hidden;min-height: 153px;box-shadow: 1px 1px 10px rgb(0 0 0 / 30%); margin-bottom: 20px; border-radius: 3px;}
.lft{float: left; width: 335px;}
.lft img{ height: 160px;width: 220px;}
.rit{float: right; width: calc(100% - 335px);}
.rit *{margin-bottom: 5px;color: #000;}
.imgs{ overflow: hidden;}
.imgs p{width: 178px; height: 178px; float: left; margin:5px; position: relative; border-radius: 6px; overflow: hidden;}
.imgs span{position: absolute; background: rgba(0,0,0,0.5); width: 100%; height: 100%; top:0;left: 0; text-align: center; display: none;}
.imgs span i{font-size: 30px; line-height: 178px; color: #fff; cursor: pointer;}
.imgs p:hover span{ display: block;}
</style>